import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface FrecuenciaRecorridoOption {
  id: number;
  descripcion: string;
  estado?: number;
}

@Injectable({
  providedIn: "root",
})
export class FrecuenciaRecorridoService {
  private apiUrl = `${environment.apiUrl}/api/frecuencia_recorrido`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(payload: Partial<FrecuenciaRecorridoOption>): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true });
  }

  update(id: number, payload: Partial<FrecuenciaRecorridoOption>): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }
}
